import { ChipOwnProps } from '@mui/material';
import {
  POSITION_FILL_REQUESTS_PATH,
  POSITION_FILL_REQUEST_READ,
  POSITION_FILL_REQUEST_SEARCH,
  POSITION_FILL_REQUEST_UPDATE,
  POSITION_FILL_REQUEST_CANCEL,
  type PositionFillRequestStatus,
  POSITION_FILL_REQUEST_STATUS,
} from 'domain/shared/positionFillRequest';

export {
  POSITION_FILL_REQUESTS_PATH,
  POSITION_FILL_REQUEST_READ,
  POSITION_FILL_REQUEST_SEARCH,
  POSITION_FILL_REQUEST_UPDATE,
  POSITION_FILL_REQUEST_CANCEL,
  POSITION_FILL_REQUEST_STATUS,
};
export type { PositionFillRequestStatus };

export const POSITION_FILL_REQUESTS_PAGE_SIZE = 100;

export const POSITION_FILL_REQUEST_STATUS_LABELS: Record<PositionFillRequestStatus, string> = {
  [POSITION_FILL_REQUEST_STATUS.REQUESTED]: 'Requested',
  [POSITION_FILL_REQUEST_STATUS.PENDING]: 'Pending',
  [POSITION_FILL_REQUEST_STATUS.REJECTED]: 'Rejected',
  [POSITION_FILL_REQUEST_STATUS.ACTIVE]: 'Active',
  [POSITION_FILL_REQUEST_STATUS.ALLOCATED]: 'Allocated',
  [POSITION_FILL_REQUEST_STATUS.EXPIRED]: 'Expired',
  [POSITION_FILL_REQUEST_STATUS.CANCELLED]: 'Cancelled',
  [POSITION_FILL_REQUEST_STATUS.COMPLETED]: 'Completed',
};

export const POSITION_FILL_REQUEST_BADGE_STATUS_COLOR: Record<PositionFillRequestStatus, ChipOwnProps['color']> = {
  [POSITION_FILL_REQUEST_STATUS.REQUESTED]: 'default',
  [POSITION_FILL_REQUEST_STATUS.PENDING]: 'default',
  [POSITION_FILL_REQUEST_STATUS.REJECTED]: 'error',
  [POSITION_FILL_REQUEST_STATUS.ACTIVE]: 'info',
  [POSITION_FILL_REQUEST_STATUS.ALLOCATED]: 'info',
  [POSITION_FILL_REQUEST_STATUS.EXPIRED]: 'error',
  [POSITION_FILL_REQUEST_STATUS.CANCELLED]: 'default',
  [POSITION_FILL_REQUEST_STATUS.COMPLETED]: 'success',
};

export const HIGHLIGHTED_POSITION_FILL_REQUEST_STATUSES: PositionFillRequestStatus[] = [
  POSITION_FILL_REQUEST_STATUS.REQUESTED,
  POSITION_FILL_REQUEST_STATUS.PENDING,
] as const;

export const EDITABLE_POSITION_FILL_REQUEST_STATUSES: PositionFillRequestStatus[] = [
  POSITION_FILL_REQUEST_STATUS.REQUESTED,
  POSITION_FILL_REQUEST_STATUS.PENDING,
  POSITION_FILL_REQUEST_STATUS.ACTIVE,
] as const;
